import { render, staticRenderFns } from "./PictureObject.vue?vue&type=template&id=7960270a&"
import script from "./PictureObject.vue?vue&type=script&lang=js&"
export * from "./PictureObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports